import { BusInfo } from "../app.model";

export abstract class StateService {

    abstract getHeartbeat(id: string): Promise<BusInfo>;

}


